<template>
  <div>
    <el-row class="page-box">
      <slot></slot>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="paging.current" :page-sizes="pageSizes" :page-size="paging.size" layout="total, sizes, prev, pager, next, jumper" :total="paging.total">
      </el-pagination>
    </el-row>
    <!-- <dialog-driver ref="dialogDriver" @upup="back"></dialog-driver> -->
  </div>
</template>
<script>
// import DialogDriver from "@/components/vehicle/dialog/dialog-driver"
export default {
  data () {
    return {
      pageSizes: [10, 20, 30, 50]
    }
  },
  created () {
    if (this.size) {
      this.pageSizes.push(this.size)
    }
    if (this.pageSizes_a) {
      this.pageSizes = this.pageSizes_a;
    }

  },
  methods: {
    handleSizeChange (size) {
      this.paging.size = size
      this.$emit('upup', this.paging)
    },
    handleCurrentChange (current) {
      this.paging.current = current
      this.$emit('upup', this.paging)
    }
  },
  props: {
    paging: {
      type: Object
    },
    size: {
      type: Number
    },
    pageSizes_a: {
      type: Array
    }

  }
}
</script>




// WEBPACK FOOTER //
// src/components/paging/paging-default.vue